
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/sketchapp",
      function () {
        return require("private-next-pages/[locale]/sketchapp/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/sketchapp"])
      });
    }
  